import React, { Fragment } from 'react';

import EmptyState from '@atlaskit/empty-state/empty-state';
import Link from '@atlaskit/link/link';

import noResultsImg from '../images/no-results.png';

const NoResults = (): React.JSX.Element => (
	<EmptyState
		header="No results found"
		description={
			<Fragment>
				If you can't find what you're looking for, try visiting the{' '}
				<Link href="/components/icon/examples">example guidelines</Link>.
			</Fragment>
		}
		imageUrl={noResultsImg}
		imageHeight={146.5}
		imageWidth={160}
	/>
);

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default NoResults;
